(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('InfectionDeleteController',InfectionDeleteController);

    InfectionDeleteController.$inject = ['$uibModalInstance', 'entity', 'Infection'];

    function InfectionDeleteController($uibModalInstance, entity, Infection) {
        var vm = this;

        vm.infection = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Infection.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
